export interface ReduxError {
    json?: { [key: string]: unknown };
    message: string;
    stack: string;
}
export enum SliceStatus {
    INIT = 'init',
    IDLE = 'idle',
    LOADING = 'loading',
    ERROR = 'error'
}
export enum SliceOperation {
    GET,
    PUT,
    POST,
    DELETE
}
/**
 * Will determin if it is usefull to refetch data
 * @param status
 * @param lastUpdate
 * @param staleTime overwrite the time between the last update in minutes (defaults to 2 minutes if no param is provided)
 * @returns
 */
export function shouldFetch(status: SliceStatus, lastUpdate: number, staleTime?: number): boolean {
    if (status === SliceStatus.INIT) return true;
    const actualStaleTime = staleTime !== undefined ? staleTime : 2;
    if (status === SliceStatus.IDLE && (new Date().getTime() - lastUpdate) / 60000 > actualStaleTime) return true;
    return false;
}

export function addOrUpdateList<T extends { id: string | number }>(element: T, list: T[]): void {
    const found = list.find((el) => el !== null && el !== undefined && el.id == element.id);
    if (found) list[list.indexOf(found)] = element;
    else list.splice(0, 0, element);
}

export function removeListElement<T extends { id: string | number }>(id: string | number, list: T[]): void {
    const found = list.find((el) => el.id == id);
    if (found) list.splice(list.indexOf(found), 1);
}
